import {
  TaxiCorporationPlanEntryBillingsItem,
  TaxiCorporationPlanEntryBillingsStats,
} from "../../../../../common/services/taxi-corporation/plan-entry-billings/list/taxi-corporation-plan-entry-billings";
import BillingModel from "../../../../../common/types/billing-model";
import BillingsTaxiRouteListingItem from "./types/billings-taxi-route-listing-item";
import BillingsTaxiRouteListingStatsSummary from "./types/billings-taxi-route-listing-stats-summary";

const createListingItemRouteAddress = (route: string[]): string => {
  return route.map((item) => item).join(", ");
};

const createListingItem = (
  responseDataItem: TaxiCorporationPlanEntryBillingsItem,
): BillingsTaxiRouteListingItem => {
  return {
    uuid: responseDataItem.uuid,
    routeId: responseDataItem.humanId,
    cargoOrderInternalIds: responseDataItem.cargoOrderHumanIds.join(", "),
    routeStartDate: new Date(responseDataItem.date),
    billingModel: responseDataItem.billingModel,
    sumOfBonuses: responseDataItem.sumOfBonuses ?? 0,
    sumOfPenalties: responseDataItem.sumOfPenalties ?? 0,
    distance: responseDataItem.distance,
    additionalDistance: responseDataItem.favorableDistance,
    amountForDistance: responseDataItem.amountForDistance ?? 0,
    baseDistanceRate: responseDataItem.baseDistanceRate,
    rateForDistance: responseDataItem.rateForDistance,
    tollRoadsCost: responseDataItem.amountForChargeHighways ?? 0,
    totalCost: responseDataItem.allContributionsAmount ?? 0,
    driverName: responseDataItem.driver,
    fleetPartner: responseDataItem.fleetPartner,
    stopoverCost: responseDataItem.amountForChargeHaltings ?? 0,
    addresses: createListingItemRouteAddress(responseDataItem.route),
  };
};

const createListingItems = (
  responseDataItems: TaxiCorporationPlanEntryBillingsItem[],
): BillingsTaxiRouteListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const createStatsSummary = (
  responseStatsSummary: TaxiCorporationPlanEntryBillingsStats,
): BillingsTaxiRouteListingStatsSummary => {
  return {
    distance: responseStatsSummary.distance,
    amountForChargeHaltings: responseStatsSummary.amountForChargeHaltings,
    amountForChargeHighways: responseStatsSummary.amountForChargeHighways,
    allContributionsAmount: responseStatsSummary.allContributionsAmount,
    sumOfBonuses: responseStatsSummary.sumOfBonuses,
    sumOfPenalties: responseStatsSummary.sumOfPenalties,
  };
};

const billingsTaxiRouteListingFactory = {
  createListingItems,
  createStatsSummary,
};

export default billingsTaxiRouteListingFactory;
